import { Controller } from "@hotwired/stimulus"

// Column-mapping step of the LV import wizard: live-highlights the spreadsheet
// columns that are mapped to target fields, gates submit on the required
// short_text mapping and warns about duplicate column assignments.
export default class extends Controller {
  static targets = ["select", "submit", "requiredHint", "duplicateHint", "headerBadge"]

  static values = { required: { type: Array, default: ["short_text"] } }

  connect() {
    this.refresh()
  }

  refresh() {
    this.paintColumns()
    this.validate()
  }

  paintColumns() {
    const mappedColumns = new Map()
    this.selectTargets.forEach((select) => {
      if (select.value !== "") mappedColumns.set(select.value, select.dataset.fieldLabel)
    })

    this.element.querySelectorAll("[data-column-index]").forEach((cell) => {
      cell.classList.toggle("bg-green-50", mappedColumns.has(cell.dataset.columnIndex))
    })

    this.headerBadgeTargets.forEach((badge) => {
      const label = mappedColumns.get(badge.dataset.columnIndex)
      badge.textContent = label || ""
      badge.classList.toggle("hidden", !label)
    })
  }

  validate() {
    const valuesByField = new Map(
      this.selectTargets.map((select) => [select.dataset.field, select.value]),
    )
    const requiredMissing = this.requiredValue.some((field) => !valuesByField.get(field))

    this.submitTarget.disabled = requiredMissing
    if (this.hasRequiredHintTarget)
      this.requiredHintTarget.classList.toggle("hidden", !requiredMissing)

    const chosen = this.selectTargets.map((select) => select.value).filter((value) => value !== "")
    const hasDuplicates = new Set(chosen).size !== chosen.length
    if (this.hasDuplicateHintTarget)
      this.duplicateHintTarget.classList.toggle("hidden", !hasDuplicates)
  }
}
